import React, { Suspense } from "react";
import { Form } from "../../../components/controls/useForm";
import FormLabel from "../../../components/HtmlMarkup/FormLabel";
import Controls from "../../../components/controls/control";
import Loading from "../../../components/Ui/Loading";
import AddIconSVG from "../../../components/svg/AddIconSVG";
import UpdateSVG from "../../../components/svg/UpdateSVG";
import CancelSVG from "../../../components/svg/CancelSVG";

export default function FormField({
  isAddForm,
  videos = [],
  values,
  handleSubmit,
  handleInputChange,
  handleCancel,
}) {
  return (
    <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="fieldContainer">
        <FormLabel htmlFor={"title"}>Title</FormLabel>
        <Controls.Input
          id="title"
          name="title"
          autocomplete="title"
          className="login-input rounded-t-md"
          placeholder="Enter assignment title"
          value={values.title}
          onChange={handleInputChange}
        />
      </div>

      <Suspense fallback={<Loading />}>
        <div className="fieldContainer">
          <FormLabel htmlFor={"video_id"}>Video Title</FormLabel>
          <Controls.Select
            id="video_id"
            name="video_id"
            placeholder="Select a video"
            className="login-input rounded-t-md cursor-pointer"
            value={values.video_id}
            onChange={handleInputChange}
            options={videos}
            optionValueKey="id"
            optionLabelKey="title"
          />
        </div>
      </Suspense>

      <div className="fieldContainer">
        <FormLabel htmlFor={"totalMark"}>Total Mark</FormLabel>
        <Controls.Input
          id="totalMark"
          name="totalMark"
          autocomplete="totalMark"
          className="login-input rounded-t-md"
          placeholder="Enter assignment totalMark"
          type="number"
          value={values.totalMark}
          onChange={handleInputChange}
        />
      </div>

      <div className="text-right ">
        <Controls.Button
          text={<span className="ml-2">{isAddForm ? "Add" : "Edit"}</span>}
          type="submit"
          startIcon={isAddForm ? <AddIconSVG /> : <UpdateSVG />}
          className="mt-24 group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-bold rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
        />
        <Controls.Button
          onClick={handleCancel}
          text={<span className="ml-2">Cancel</span>}
          startIcon={<CancelSVG />}
          className="mt-4 group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-bold rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
        />
      </div>
    </Form>
  );
}
